import { render } from "./TheSiteDescription.vue?vue&type=template&id=81a31e3e&scoped=true&ts=true"
import script from "./TheSiteDescription.vue?vue&type=script&lang=ts"
export * from "./TheSiteDescription.vue?vue&type=script&lang=ts"

import "./TheSiteDescription.vue?vue&type=style&index=0&id=81a31e3e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81a31e3e"]])

export default __exports__